<script setup lang="ts">
import { Enums } from "@/enums";
import { computed } from "vue";
import { assertUnhandledStatus } from "../../common/asserts.common";

const props = defineProps<{
    status: Enums.ProvisionStatusEnum.Values;
}>();

const label = computed(() => Enums.ProvisionStatusEnum.label(props.status));
const color = computed(() => {
    switch (props.status) {
        case "W":
            return "bg-blue-500";
        case "P":
            return "bg-yellow-500";
        case "R":
            return "bg-green-500";
        case "D":
            return "bg-black";
        case "C":
            return "bg-red-500";
        default:
            return assertUnhandledStatus(props.status);
    }
});
</script>

<template>
    <div class="rns-g-badge" :class="color">{{ label }}</div>
</template>

<style>
@reference "@/styles/main.css";
</style>
